import React from 'react';
// import { COMPANY_TEXT_ID } from 'src/newSrc/constants/companyTextIdConstants';

export const SCREEN_CONFIG = {
  default: {
    ScreenConfigNotFoundScreen: React.lazy(
      () => import('../default/ScreenConfigNotFoundScreen')
    ),
    // RFQCreate: React.lazy(() => import('../RFQ/CreateReverseAuction/index')),
    SeekerHomeScreen: React.lazy(() => import('../default/seekerHomeScreen')),
    RFQCreate: React.lazy(() => import('../default/CreateRFQ/RFQCreate')),
    RfqDashboardScreen: React.lazy(
      () => import('../default/RfqDashboardScreen')
    ),
    BidDetailsScreen: React.lazy(() => import('../default/BidDetailsScreen')),
    ChallengePriceForm: React.lazy(
      () => import('../default/ChallengePriceForm')
    ),
  },
  // [COMPANY_TEXT_ID.DPL_SAP]: {
  //   RaiseIndentScreen: React.lazy(() => import('../dpl/RaiseIndentScreen')),
  // },
  // beams: {},
  // emami: {},
};

// Helper function to get screen component by company and screen component name
export const getScreenComponent = (COMPANY_TEXT_ID, screenComponentName) => {
  // Check if company has custom screen
  // if (COMPANY_TEXT_ID) {
  //   const companyScreenConfig = SCREEN_CONFIG[COMPANY_TEXT_ID];
  //   if (companyScreenConfig && companyScreenConfig[screenComponentName]) {
  //     return companyScreenConfig[screenComponentName];
  //   }
  // }

  // Use default screen if available
  if (SCREEN_CONFIG.default[screenComponentName]) {
    return SCREEN_CONFIG.default[screenComponentName];
  }

  // Fallback to ScreenConfigNotFoundScreen if screen is not found
  return SCREEN_CONFIG.default.ScreenConfigNotFoundScreen;
};
